import { jsx as _jsx } from "react/jsx-runtime";
import { AdSlot, AdUnderstitial, useAdsContext } from '@search/ads';
import { useBrandConfiguration } from '@search/core/brands/context';
import { Order } from '@search/core/brands/models/Order';
import { CardLoader } from '@search/core/components/CardLoader';
import { ScrollableListView as CoreScrollableListView } from '@search/core/components/ScrollableListView';
import { useListContent } from '@search/core/hooks/useListContent';
import { useMobile } from '@search/core/hooks/useMobile';
import useViewedClassifiedsTracking from '@search/core/hooks/useViewedClassifiedTracking';
import { Place } from '@search/core/services/analytics';
import { range } from 'lodash';
import { useAppContext } from '../../contexts/AppContext';
import { Card } from '../Card';
export const CardLoaderTestId = 'serp-card-loader-test-id';
export const ScrollableListView = () => {
    const { ads, autoPromo, suggestionSlots, filterVisibleAds, brand } = useBrandConfiguration();
    const [classifiedIds, searchModel, isLoading, suggestedClassifieds = [], enrichedClassifiedsData = {}, page, order, totalCount, forceXxlTopPosition, enableTopPosition, topPositionIdStore,] = useAppContext((store) => [
        store.classifieds,
        store.searchModel,
        store.isLoading,
        store.suggestedClassifieds,
        store.enrichedClassifiedsData,
        store.page,
        store.order,
        store.totalCount,
        store.featureFlags?.[`abtest-serp-${brand}-force-xxl-top-position`] === true,
        store.featureFlags?.['serp-enable-top-position'] === true,
        store.topPositionId,
    ]);
    const { adsEnabled } = useAdsContext();
    const { isMobile } = useMobile();
    // if top position enabled => use topPositionId from the store (coming from the otp api)
    // else use the first classifiedId (abtest mode)
    const abtestXxlTopPosition = !enableTopPosition &&
        forceXxlTopPosition &&
        order === Order.Relevancy &&
        page === 1 &&
        classifiedIds.length > 0 &&
        enrichedClassifiedsData[classifiedIds[0]]?.size === 'XL';
    let topPositionId;
    if (enableTopPosition && order === Order.Relevancy && page === 1)
        topPositionId = topPositionIdStore;
    else if (abtestXxlTopPosition)
        topPositionId = classifiedIds[0];
    const classfieldFilteredIds = abtestXxlTopPosition ? classifiedIds.slice(1) : classifiedIds;
    const listContent = useListContent({
        classifiedIds: classfieldFilteredIds,
        searchModel,
        adsEnabled,
        ads,
        filterVisibleAds,
        autoPromo,
        suggestedClassifieds,
        suggestionSlots,
        topPositionId,
    });
    useViewedClassifiedsTracking({
        subtype: 'CLASSIFIED_CARD_VIEW',
        place: Place.SERP_PAGE,
        classifiedIds,
        page,
        order,
        totalCount,
    });
    if (isLoading) {
        return range(isMobile ? 2 : 6).map((id) => _jsx(CardLoader, { testId: CardLoaderTestId }, id));
    }
    return (_jsx(CoreScrollableListView, { listContent: listContent, Card: Card, AdUnderstitial: AdUnderstitial, AdSlot: AdSlot }));
};
